import { account } from '../../../../../classes/Account'
import { formatPhoneNumber } from '../../../../../utilities/extensions'

export default function DashboardClientTile() {
  return (
    <div className='w-full lg:w-1/3 p-6 rounded-2xl bg-white dark:bg-slate-800 border border-gray-100 dark:border-slate-700 shadow-sm flex flex-col gap-4 transition-colors duration-300'>
      <p className='font-bold text-lg sm:text-xl text-slate-800 dark:text-white'>Client Information</p>
      <div className='w-full flex flex-row items-center justify-between text-sm sm:text-base'>
        <p className='font-bold text-slate-600 dark:text-slate-300'>Name:</p>
        <p className='text-slate-800 dark:text-gray-100'>{account.name}</p>
      </div>
      <div className='w-full flex flex-row items-center justify-between text-sm sm:text-base'>
        <p className='font-bold text-slate-600 dark:text-slate-300'>Entity:</p>
        <p className='text-slate-800 dark:text-gray-100'>{account.company}</p>
      </div>
      <div className='w-full flex flex-row items-center justify-between text-sm sm:text-base'>
        <p className='font-bold text-slate-600 dark:text-slate-300'>Email:</p>
        <p className='text-slate-800 dark:text-gray-100'>{account.email}</p>
      </div>
      <div className='w-full flex flex-row items-center justify-between text-sm sm:text-base'>
        <p className='font-bold text-slate-600 dark:text-slate-300'>Phone:</p>
        <p className='text-slate-800 dark:text-gray-100'>{formatPhoneNumber(account.phone)}</p>
      </div>
    </div>
  )
}